// Component for grouping users and apps bar charts
import React from 'react';
import BarChart from '../graphs/Barchart';

export const BarChartContainer = ({ userData, appData, userColorScale, appColorScale }) => {
	return (
		<div style={outerStyles}>
			<div style={innerStyles}>
				<h3 style={h1Style}>User Details</h3>
				<BarChart data={userData} height={100} colorScale={userColorScale} />
			</div>

			<div style={innerStyles}>
				<h3 style={h1Style}>App Details</h3>
				<BarChart data={appData} height={100} colorScale={appColorScale} />
			</div>
		</div>
	);
};

const outerStyles = {
	display: 'flex',
	flexDirection: 'row'
};

const innerStyles = {
	flex: '1'
};

const h1Style = {
	display: 'block',
	marginTop: '10px',
	color: '#707070',
	textAlign: 'center',
	fontSize: '1em'
};
export default BarChartContainer;
